export const INSTALLMENT_ANTICIPATION = {
  INITIAL: "INITIAL",
  DETAIL: "DETAIL",
  SIMULATION: "SIMULATION",
  ANTICIPATION: "ANTICIPATION",
};
